/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const CREATE_BATCH_QR = gql`
    mutation CreateBatchLazyBindingParent {
        createBatchLazyBindingParent {
            _id
            description
            dateKey
            counterRef
            parentId
            hash
            urlEncodedHash
            createdBy
            creatorRole
            creatorType
            createdAt
            updatedAt
            batch {
                _id
                name
            }
            product {
                _id
                name
            }
            gtin {
                _id
                item
                name
            }
        }
    }
`;
